<script lang="ts" setup>
import { useLoginStore } from '@/login/stores/useLoginStore';
import { storeToRefs } from 'pinia';

const loginStore = useLoginStore();
const { selectedInstance, isSupport } = storeToRefs(loginStore);

const acceptInstanceChanged = (): void => {
    loginStore.setInstanceChangedWarning(false);
};
</script>

<template>
    <SStack
        vertical
        justify-content="center"
        align-items="center"
        class="h-100"
    >
        <div class="text-center">
            <SHeading is="h2">{{ $t('system.instanceChanged') }}</SHeading>
            <SText is="p" class="free-width my-2">{{ $t('system.instanceChangedDescription') }}</SText>
            <SHeading is="h3" class="free-width mt-6 mb-2">{{ selectedInstance?.Name }}</SHeading>
            <SText is="p" v-if="isSupport" class="free-width font-weight-bold">{{ selectedInstance?.SubDomain }}</SText>
            <SText is="p" class="free-width mt-6">{{ $t('system.instanceChangedDescriptionMore') }}</SText>
            <SButton
                variant="primary"
                class="mt-6"
                @click="acceptInstanceChanged"
            >
                {{ $t('system.instanceChangedButton') }} {{ selectedInstance?.Name }}
            </SButton>
        </div>
    </SStack>
</template>
